import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const MarkdownRenderer = ({ markdown }) => {
    return (
        <div className="prose dark:prose-invert max-w-none">
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                    h1: ({ children }) => <h1 className="text-2xl font-bold my-4">{children}</h1>,
                    h2: ({ children }) => <h2 className="text-xl font-semibold my-3">{children}</h2>,
                    h3: ({ children }) => <h3 className="text-lg font-medium my-2">{children}</h3>,
                    p: ({ children }) => <p className="text-gray-700 dark:text-gray-300 my-2">{children}</p>,
                    ul: ({ children }) => <ul className="list-disc list-inside my-4">{children}</ul>,
                    li: ({ children }) => <li className="ml-4">{children}</li>,
                    a: ({ href, children }) => (
                        <a href={href} className="text-blue-500 hover:underline">
                            {children}
                        </a>
                    ),
                }}
            >
                {markdown}
            </ReactMarkdown>
        </div>
    );
};

export default MarkdownRenderer;